import { render, staticRenderFns } from "./AutomatedABTest.vue?vue&type=template&id=706cb363&scoped=true&"
import script from "./AutomatedABTest.vue?vue&type=script&lang=js&"
export * from "./AutomatedABTest.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedABTest.vue?vue&type=style&index=0&id=706cb363&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706cb363",
  null
  
)

export default component.exports